import React from 'react';
const SettingsIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    viewBox="0 0 92 107.5"
    {...props}>
    <g>
      <circle fill={props.color} cx="11.5" cy="78.5" r="11.5" />
      <circle fill={props.color} cx="46" cy="29.5" r="11.5" />
      <circle fill={props.color} cx="80.5" cy="59.5" r="11.5" />
      <path
        fill={props.color}
        d="M15,60.51V3.5a3.5,3.5,0,0,0-7,0v57a18.18,18.18,0,0,1,7,0Z"
      />
      <path
        fill={props.color}
        d="M8,96.49V104a3.5,3.5,0,0,0,7,0V96.49a18.18,18.18,0,0,1-7,0Z"
      />
      <path
        fill={props.color}
        d="M49.5,11.51v-8a3.5,3.5,0,0,0-7,0v8a18.18,18.18,0,0,1,7,0Z"
      />
      <path
        fill={props.color}
        d="M42.5,47.49V104a3.5,3.5,0,0,0,7,0V47.49a18.18,18.18,0,0,1-7,0Z"
      />
      <path
        fill={props.color}
        d="M84,42.18V3.5a3.5,3.5,0,0,0-7,0V42.18a17.67,17.67,0,0,1,7,0Z"
      />
      <path
        fill={props.color}
        d="M77,78.16V104a3.5,3.5,0,0,0,7,0V78.16a18.18,18.18,0,0,1-7,0Z"
      />
    </g>
  </svg>
);

export default SettingsIcon;
